module.exports = __webpack_public_path__ + "static/media/img-mygood-product-1@2x.df71c88f.png";